import { KzIcon } from '../generated-icons/kz-icon.model';
import { kzIconsSocialFacebook } from '../generated-icons/kzIcons-social-facebook.icon';
import { kzIconsSocialInstagram } from '../generated-icons/kzIcons-social-instagram.icon';
import { kzIconsSocialLinkedin } from '../generated-icons/kzIcons-social-linkedin.icon';
import { kzIconsSocialPinterest } from '../generated-icons/kzIcons-social-pinterest.icon';
import { kzIconsSocialTwitter } from '../generated-icons/kzIcons-social-twitter.icon';
import { kzIconsSocialWebsite } from '../generated-icons/kzIcons-social-website.icon';
import { kzIconsSocialYoutube } from '../generated-icons/kzIcons-social-youtube.icon';
import { kzIconsSocialMessages } from '../generated-icons/kzIcons-social-messages.icon';

export const socialIcons: KzIcon[] = [
  kzIconsSocialFacebook,
  kzIconsSocialInstagram,
  kzIconsSocialLinkedin,
  // kzIconsSocialMessenger,
  kzIconsSocialMessages,
  kzIconsSocialPinterest,
  // kzIconsSocialSignal,
  // kzIconsSocialSnapchat,
  kzIconsSocialTwitter,
  kzIconsSocialWebsite,
  // kzIconsSocialWhatsapp,
  kzIconsSocialYoutube,
];
